import { ArrowRight, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Cards from '../elements/Cards';
import Hero from '../elements/Hero';
import HomeSlideshow from '../elements/HomeSlideshow';
import { guidePages, img, industryPages, products } from '../data/siteData';

function Home() {
  return (
    <>
      <Hero
        eyebrow="C+M Baling Systems"
        title="Industrial Baling Equipment"
        description="Standard and custom baling equipment for industrial, commercial, recycling, textile, paper, and manufacturing applications."
        image="equipment/horizontal-balers/horizontal-7.jpg"
      />
      <main>
        <section className="intro split">
          <div>
            <span className="eyebrow">A Practical Approach</span>
            <h2>Engineered Around Your Workflow</h2>
            <p>C+M designs and manufactures balers for facilities that need reliable equipment for <strong>waste reduction</strong>, recycling, <strong>material handling</strong>, and production support.</p>
            <p>Balers are engineered with simplicity, serviceability, and safety in mind, using standard hydraulic components and durable structures built for years of service.</p>
            <Link className="text-link" to="/baler-selection-guide">Find the Right Baler <ArrowRight size={16} /></Link>
          </div>
          <HomeSlideshow />
        </section>
        <section>
          <div className="band">
            <div>
              <span className="eyebrow">Baler Selection Guide</span>
              <h2>A Better Recommendation Starts with Your Material</h2>
              <p>Material type, infeed size, <strong>hourly volume</strong>, bale size, available space, <strong>loading method</strong>, and electrical power all shape the correct baling press recommendation.</p>
            </div>
            <Link className="button light" to="/contact/questionnaire">Start the Questionnaire <ArrowRight size={16} /></Link>
          </div>
        </section>
        <section>
          <span className="eyebrow">Most Requested</span>
          <h2>Start with Common C+M Equipment Paths</h2>
          <Cards items={[
            products[0],
            {
              ...products.find((item) => item.slug === 'open-end-automatic-tie-balers'),
              image: 'equipment/horizontal-balers/horizontal-1.jpg',
            },
            {
              ...products.find((item) => item.slug === 'wide-mouth-open-end-automatic-tie-balers'),
              image: 'thumbnails/WideMouthAutomaticPic1.jpg',
            },
            { ...guidePages[0], title: 'Open-End Horizontal Manual Tie Balers' },
            { ...guidePages[2], image: 'equipment/compactors/operation.jpg' },
            products.find((item) => item.slug === 'cart-lifters-dumpers-dump-carts'),
          ]} />
        </section>
        <section>
          <article className="home-news" aria-labelledby="home-news-title">
            <img
              src={img('cm-american-recycler-november-2026.jpg')}
              alt="C+M horizontal baler and feed conveyor processing cardboard in a facility"
              loading="lazy"
              decoding="async"
              width="1000"
              height="573"
            />
            <div className="home-news-copy">
              <span className="eyebrow">In the News</span>
              <h3 id="home-news-title">C+M in the Spotlight</h3>
              <p>In November 2026, American Recycler featured C+M in its Baler Equipment Spotlight, sharing our approach to durable equipment, automation, and finding the right baling system for each operation.</p>
              <a className="text-link" href="https://americanrecycler.com/features/equipment-spotlight/equipment-spotlight-november-2026-balers/" target="_blank" rel="noopener noreferrer">
                Read the Article <ArrowRight size={16} aria-hidden="true" />
              </a>
            </div>
          </article>
        </section>
        <section className="industries">
          <span className="eyebrow">Who We Serve</span>
          <h2>Solutions for Complex Material Streams</h2>
          <div>
            {industryPages.map((item) => (
              <Link key={item.slug} to={`/${item.slug}`}>{item.title}<ChevronRight size={18} /></Link>
            ))}
          </div>
        </section>

      </main>
    </>
  );
}

export default Home;
